import { DotMenuIcon, DotMenuToggle } from '../../../components/DotMenu';

export const MenuIcon = DotMenuIcon;
export default DotMenuToggle;
